import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

function VoteButtons({ voteKey, question }) {
  const [votes, setVotes] = useState({ up: 0, down: 0 });
  const [voted, setVoted] = useState(!!localStorage.getItem('vote_' + voteKey));

  useEffect(() => {
    const load = async () => {
      try {
        const snap = await getDoc(doc(db, 'goodnews', voteKey));
        if (snap.exists()) setVotes(snap.data());
      } catch(e) {}
    };
    load();
  }, [voteKey]);

  const vote = async (type) => {
    if (voted) return;
    localStorage.setItem('vote_' + voteKey, '1');
    setVoted(true);
    const newVotes = { ...votes, [type]: (votes[type] || 0) + 1 };
    setVotes(newVotes);
    try {
      await setDoc(doc(db, 'goodnews', voteKey), newVotes, { merge: true });
    } catch(e) {}
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
      {question && <span style={{ color: '#aaa', fontSize: '14px' }}>{question}</span>}
      {voted ? (
        <>
          <span style={{ color: '#4CAF50', fontSize: '14px', fontWeight: 'bold' }}>👍 {votes.up || 0}</span>
          <span style={{ color: '#f44336', fontSize: '14px', fontWeight: 'bold' }}>👎 {votes.down || 0}</span>
        </>
      ) : (
        <>
          <button onClick={() => vote('up')} style={{ padding: '4px 12px', backgroundColor: '#1a3a1a', border: '1px solid #4CAF50', borderRadius: '8px', cursor: 'pointer', fontSize: '24px' }}>👍</button>
          <button onClick={() => vote('down')} style={{ padding: '4px 12px', backgroundColor: '#3a1a1a', border: '1px solid #f44336', borderRadius: '8px', cursor: 'pointer', fontSize: '24px' }}>👎</button>
        </>
      )}
    </div>
  );
}

export default VoteButtons;